const cards = [
  {
    id: "yaxin",
    label: "THE BRAIN",
    title: "YAXIN",
    subtitle: "Hangzhou HQ",
    role: "Sourcing & Data Hub",
    description:
      "30 years of deep-rooted expertise in the Chinese automotive parts landscape. Manages the master OE database, supplier qualification, and quality benchmarking — the intelligence layer of the entire operation.",
    stat: "30 YRS",
    statLabel: "Industry Expertise",
    image: "https://public.readdy.ai/ai/img_res/6fc56d7e2fc413e13ab6a82916f3bebb.jpg",
  },
  {
    id: "chirun",
    label: "THE ENGINE",
    title: "CHIRUN",
    subtitle: "Guangzhou Export Hub",
    role: "Global Export Operations",
    description:
      "The operational core handling all international trade execution. PO processing, legally binding international contracts, customs documentation, and end-to-end fulfillment from China to global destinations.",
    stat: "FCL / LCL",
    statLabel: "Export Capability",
    image: "https://readdy.ai/api/search-image?query=dramatic%20night%20photograph%20of%20Canton%20Tower%20Guangzhou%20China%20illuminated%20with%20colorful%20lights%20reflecting%20on%20Pearl%20River%20modern%20skyline%20with%20container%20port%20cranes%20in%20background%20urban%20metropolis%20cinematic%20photography%20ultra%20high%20resolution&width=700&height=500&seq=trinity-guangzhou-01&orientation=portrait",
  },
  {
    id: "xylp",
    label: "THE FORTRESS",
    title: "XYLP",
    subtitle: "Russia — EAEU Division",
    role: "Compliance & Distribution",
    description:
      "Localized EAEU regulatory compliance, in-market distribution, and direct customer relationships across Russia and Central Asian markets. Ensures seamless last-mile delivery within the Eurasian Economic Union.",
    stat: "EAEU",
    statLabel: "Certified Compliance",
    image: "https://readdy.ai/api/search-image?query=breathtaking%20night%20photograph%20of%20Saint%20Basils%20Cathedral%20Moscow%20Russia%20Red%20Square%20illuminated%20with%20warm%20golden%20lights%20against%20deep%20blue%20night%20sky%20with%20snow%20on%20ground%20dramatic%20winter%20atmosphere%20cinematic%20ultra%20high%20resolution%20photography&width=700&height=500&seq=trinity-moscow-01&orientation=portrait",
  },
];

export default function TrinitySection() {
  return (
    <section id="trinity" className="py-28 px-6" style={{ background: "#0d1525" }}>
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <p className="text-xs tracking-widest uppercase mb-4 font-medium" style={{ color: "#F59E0B", letterSpacing: "0.25em" }}>
            Corporate Architecture
          </p>
          <h2 className="text-4xl md:text-5xl font-thin mb-4 text-white" style={{ letterSpacing: "0.05em" }}>
            THE TRINITY INFRASTRUCTURE
          </h2>
          <div className="mx-auto mt-5" style={{ width: "60px", height: "2px", background: "#F59E0B" }} />
          <p className="mt-6 text-sm font-light max-w-xl mx-auto" style={{ color: "rgba(255,255,255,0.55)", lineHeight: "1.8" }}>
            Three specialized entities. One seamless supply chain. Each node engineered for a
            distinct function — together forming an unbreakable B2B infrastructure.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {cards.map((card, idx) => (
            <div
              key={card.id}
              className="group relative rounded-2xl overflow-hidden cursor-default flex flex-col"
              style={{
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.08)",
                boxShadow: "0 2px 16px rgba(0,0,0,0.2)",
                transition: "border-color 0.3s, transform 0.3s, box-shadow 0.3s",
              }}
              onMouseEnter={(e) => {
                const el = e.currentTarget as HTMLDivElement;
                el.style.borderColor = "rgba(245,158,11,0.45)";
                el.style.transform = "translateY(-6px)";
                el.style.boxShadow = "0 20px 48px rgba(0,0,0,0.35)";
              }}
              onMouseLeave={(e) => {
                const el = e.currentTarget as HTMLDivElement;
                el.style.borderColor = "rgba(255,255,255,0.08)";
                el.style.transform = "translateY(0)";
                el.style.boxShadow = "0 2px 16px rgba(0,0,0,0.2)";
              }}
            >
              {/* City Image */}
              <div className="relative h-56 overflow-hidden shrink-0">
                <img
                  src={card.image}
                  alt={card.subtitle}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div
                  className="absolute inset-0"
                  style={{ background: "linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.55) 100%)" }}
                />
                <span
                  className="absolute top-4 right-4 text-xs font-mono px-2 py-1 rounded"
                  style={{ background: "rgba(245,158,11,0.85)", color: "#ffffff", fontWeight: 700 }}
                >
                  0{idx + 1}
                </span>
                <div className="absolute bottom-4 left-5">
                  <p className="text-xs tracking-widest uppercase font-medium text-white/90" style={{ letterSpacing: "0.2em" }}>
                    {card.label}
                  </p>
                </div>
              </div>

              {/* Content */}
              <div className="flex flex-col flex-1 p-7">
                <h3 className="text-xl font-bold mb-0.5 text-white" style={{ letterSpacing: "0.1em" }}>
                  {card.title}
                </h3>
                <p className="text-sm mb-1 font-medium" style={{ color: "#F59E0B" }}>
                  {card.subtitle}
                </p>
                <p className="text-xs uppercase tracking-widest mb-5" style={{ color: "rgba(255,255,255,0.35)", letterSpacing: "0.15em" }}>
                  {card.role}
                </p>
                <div className="mb-5" style={{ width: "36px", height: "1.5px", background: "#F59E0B" }} />
                <p className="text-sm font-light leading-relaxed flex-1" style={{ color: "rgba(255,255,255,0.6)", lineHeight: "1.85" }}>
                  {card.description}
                </p>
                <div
                  className="mt-6 pt-5 flex items-center justify-between"
                  style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}
                >
                  <div>
                    <p className="text-lg font-bold" style={{ color: "#F59E0B" }}>{card.stat}</p>
                    <p className="text-xs mt-0.5" style={{ color: "rgba(255,255,255,0.35)" }}>{card.statLabel}</p>
                  </div>
                  <div
                    className="w-8 h-8 flex items-center justify-center rounded-lg"
                    style={{ background: "rgba(245,158,11,0.12)", border: "1px solid rgba(245,158,11,0.3)" }}
                  >
                    <i className="ri-arrow-right-up-line text-sm" style={{ color: "#F59E0B" }} />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
